module.exports = __webpack_public_path__ + "a17d279f/img/saly-icon.39e12342.jpg";